import * as React from 'react';
import i18n from 'i18n-react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import FormatValue from '../../../../utils/FormatValue';

import './PaymentDetail.css';
import { PaymentType } from '../../../../const/PaymentType';

const propTypes = {
  data: PropTypes.any
};

function PaymentDetail(props) {
  const isPnrSplited = props.data.pnrSplit && props.data.pnrSplit.pnrParent;
  return (
    <div className="PaymentDetail margin-eight-horizontal-24" data-test="paymentDetail">
      <Row className="padding-eight-bottom-16 text-dark-blue text-500">
        <Col span={8} className="text-left">
          {i18n.translate('features.paymentDetail.yourItems')}
        </Col>
        <Col span={8} className="text-center">
          {i18n.translate('features.paymentDetail.pointsValue')}
        </Col>
        <Col span={8} className="text-right">
          {i18n.translate('features.paymentDetail.moneyValue')}
        </Col>
      </Row>

      <div className="PaymentDetail__prices margin-eight-bottom-24">
        {getPrice('ADULT', props.data.passengers, props.data.cart.items[0], props.data)}
        {getPrice('CHILD', props.data.passengers, props.data.cart.items[0], props.data)}
        {getPrice('INFANT', props.data.passengers, props.data.cart.items[0], props.data)}
      </div>
      <hr className="PaymentDetail__line bg-white-three" />

      {renderPointsAndMoneyLine(
				i18n.translate('features.paymentDetail.taxValue') ,
				null,
				getFormatedValue(props.data.totalTxEmbarque, props.data),
				'PaymentDetail__moneyLine text-warm-grey-two',
				'moneyRow'
			)}

       {props.data.isRebooking ?
				renderPointsAndMoneyLine(
					i18n.translate('features.paymentDetail.taxAlteracaoValue'),
					null,
					getFormatedTxAlteracao(props.data.totalTaxaAlteracao),
					'PaymentDetail__moneyLine text-warm-grey-two',
					'moneyRow'
				) : ""}

			<hr className="PaymentDetail__line bg-white-three" />

			{renderPointsAndMoneyLine(
				i18n.translate('features.paymentDetail.totalTo', {
					passengerNumber: props.data.passengers.length - countPassagerSplit(props.data) ,
					passengerText:
						props.data.passengers.length > 1
							? i18n.translate('label.passengers')
							: i18n.translate('label.passenger')
				}) ,
				getPointsFormatted(props.data.cart.total, props.data),
				getFormatedValue(props.data.cart.total, props.data),
				`PaymentDetail__totalLine 
					padding-eight-top-24 padding-eight-bottom-40 
					text-dark-blue text-lg`,
				'totalRow'
			)}

			<hr className="PaymentDetail__line bg-white-three" />      

      <div className="text-dark-blue padding-eight-top-16">
        {props.data.payment.items.map(payment => {
          const isRenderInfoPaymentWhenPnrSplited = isPnrSplited && payment.paymentType == PaymentType.BOOKING && !payment.paymentAdicional;
					 return (
               <Row className="PaymentDetail__cardInformation">
                   <Col
                     span={8}
                     data-test="paymentCardLabel"
                     className="d-table-cell text-left text-500 padding-top-xs">
                     {i18n.translate('features.paymentDetail.paymentMethod')}
                    </Col>
                    <Col span={8} className="text-center text-300 padding-top-xs">
                        <div
                          data-unit="paymentCardBrand"
                          data-test="paymentCardBrand"
                          className={`v-align-middle margin-eight-right-8 cards cards--${payment.vendorCode.toString()} selected`}
                         />
                        <span data-unit="paymentCardLast" data-test="paymentCardLast">
                            •••• {payment.cardNumberLast}
                        </span>
                    </Col>
                    {!isRenderInfoPaymentWhenPnrSplited 
                    ? totalPayment(payment.value, props.data, payment.paymentAdicional)
                    : renderInfoPaymentWhenPnrSplited(props.data.pnrSplit.pnrParent.pnrCode)}
              </Row>
            )
        })}

        <hr className="PaymentDetail__line bg-white-three" />

        {renderPointsAndMoneyLine(
          i18n.translate('features.paymentDetail.paymentAdicional'),
          getFormatedPointsAdicional(props.data.totalPointPaymentAdicional),
          getFormatedValueAdicional(props.data.totalValuePaymentAdicional),
          `d-table-cell text-left text-500 padding-top-xs`,
          'totalRow'
        )}
        <hr className="PaymentDetail__line bg-white-three" />
      </div>
    </div>
  );
}

function totalPayment (value, data, paymentAdicional) {

	if (data.installment == undefined || data.installment.installment == 1 || paymentAdicional) {
		return (
			<Col span={8} className="text-300 text-right padding-top-xs">
				{i18n.translate('features.paymentDetail.inCash')}{' '}
				{i18n.translate('label.currency')}{' '}
				<span className="text-500" data-test="paymentCardTotal">
					{getFormatedValuePayment(value)}
				</span>
				</Col>
		)
	}
	
	if (data.installment != undefined && data.installment.installment > 1) {
		return (
			<Col span={8} className="text-300 text-right padding-top-xs">
				{i18n.translate('label.currency')}{' '}
				<span className="text-500" data-test="paymentCardTotal">
					{getFormatedValuePayment(value)}
				</span>
				{' em ' + data.installment.installment + ' x '}
				<span className="text-500">
				{data.installment.interestsInstallment ? i18n.translate('features.paymentDetail.withInterests') :
				 i18n.translate('features.paymentDetail.withoutInterests')}
				</span>
			</Col>
		)
	}
}

function getFormatedPointsAdicional(total) {
  var result = 0;
  const pattern = /\B(?=(\d{3})+(?!\d))/g;
  if (total.length > 0 && total !== undefined) {
    result = total.reduce((acumulado, b) => b.value + acumulado, 0);
  }
  return result === 0 ? '' : result.toString().replace(pattern, '.');
}

function getFormatedValueAdicional(total) {
  var result = 0;
  if (total.length > 0 && total !== undefined) {
    result = total.reduce((acumulado, b) => b.value + acumulado, 0);
  }
  return result === 0
    ? ''
    : result
        .toFixed(2)
        .toString()
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+,)/g, '$1.');
}

function getFormatedTxAlteracao(valor) {
	var result = 0;
	if (valor.length > 0 && valor !== undefined) {
		result = valor
			.reduce((acumulado, b) => b.value + acumulado, 0);
	}
	return result === 0 ? "" : result.toFixed(2).toString().replace('.', ',').replace(/(\d)(?=(\d{3})+,)/g, '$1.');
}

function getFormatedValuePayment(valor) {
	return valor === 0 ? "" : valor.toFixed(2).toString().replace('.', ',').replace(/(\d)(?=(\d{3})+,)/g, '$1.');
}


function getPointsFormatted(total, pnr) {
	let valorReturn;
	const pattern = /\B(?=(\d{3})+(?!\d))/g;

	if (pnr.totalRebooking.points) {
		valorReturn = pnr.totalRebooking.points.value;
	} else {
		valorReturn = total
			.filter(item => item.currency === 'POINTS')[0]
			.value;
	}
    
	return valorReturn.
		toString().
		replace(pattern, '.');
}

function getFormatedValue(total, pnr) {
	let valorReturn;
	const pattern = /(\d)(?=(\d{3})+,)/g;

	valorReturn =
		total
			.filter(item => item.currency === 'BRL')[0]
			.value.toFixed(2);

	valorReturn = Number(valorReturn).toFixed(2);

	return valorReturn.
		toString()
		.replace('.', ',')
		.replace(pattern, '$1.');
}

function renderPointsAndMoneyLine(name, pointsValue, moneyValue, classes, label) {
  const pointsTudoAzul = (
    <div>
      <span data-test="totalAndTaxPoints">{pointsValue}</span>
      <span
        data-unit="paymentRowPointsLabel"
        className="text-300 text-xs margin-eight-left-8 text-dark-blue">
        <b>{i18n.translate('label.tudoAzul.points')}</b>
      </span>
    </div>
  );
  return (
    <div className={`padding-eight-vertical-16 ${classes}`}>
      <Row data-test={label}>
        <Col span={8} data-test="totalAndTaxLabel" className="text-left">
          {name}
        </Col>
        <Col span={8} className="text-center text-500 padding-top-xs">
          {pointsValue ? pointsTudoAzul : <span data-test="totalAndTaxPoints">--</span>}
        </Col>
        <Col span={8} className="text-right text-500 padding-top-sm">
          {moneyValue === '' ? '--' : i18n.translate('label.currency')}{' '}
          <span data-test="totalAndTaxMoney" className="text-md text-500">
            {moneyValue}
          </span>
        </Col>
      </Row>
    </div>
  );
}

function getPrice(type, passengers, flight,pnr) {
  const countPassengers = passengers.filter(passenger => passenger.passengerType === type);
  let render;
  if (countPassengers.length > 0) {
    const passengerMessage =
      countPassengers.length > 1
        ? i18n.translate('label.passengers')
        : i18n.translate('label.passenger');
    const typeMessage = countPassengers.length > 1 ? `${type}S` : type;
    const countPassegerRemoveSplit = countPassagerSplitByType(pnr, type);
    render = (
      <Row data-unit={`passengerRow--${type}`} className="text-warm-grey-two">
        <Col
          span={8}
          className={`text-left ${type}-countPassengers`}
          data-test={`${type}-countPassengers`}>
          {countPassengers.length - countPassegerRemoveSplit} {passengerMessage}{' '}
          <b>{i18n.translate(`features.paymentDetail.${typeMessage}`)}</b>
        </Col>
        <Col
          span={8}
          className={`text-center text-400  ${type}-pointsPrice`}
          data-test={`${type}-pointsPrice`}>
           {getFlightPrices(flight, type, countPassengers.length,pnr)} 
        </Col>
        <Col span={8} className={`text-right ${type}-moneyPrice`} data-test={`${type}-moneyPrice`}>
          {getFlightMoney(flight, type)}
        </Col>
      </Row>
    );
  }
  return render;
}

function getFlightPrices(flight, type, passengersNumber,pnr) {
  const departurePrice = flight.departureFlight.prices.filter(price => price.passenger === type)[0]
    .value;

  const returnPrice = flight.returnFlight
    ? flight.returnFlight.prices.filter(price => price.passenger === type)[0].value
    : 0;

  let pricesByType = departurePrice + returnPrice;
  const pattern = /\B(?=(\d{3})+(?!\d))/g;

  return (
    <div>
      <span data-test={`${type}-pointsPrice-value`}>
        {pricesByType.toString().replace(pattern, '.')}
      </span>
      <span className="text-300 text-xs margin-eight-left-8 text-warm-grey-two">
        <b>{i18n.translate('label.tudoAzul.points')}</b>
      </span>
    </div>
  );
}

function getFlightMoney(flight, type) {
	let departureMoney = 0;
	let returnMoney = 0;

	if (flight.departureFlight.money.length > 0) {
		departureMoney = flight.departureFlight.money.filter(money => money.passenger === type)[0].value;
	}

	if (flight.returnFlight && flight.returnFlight.money.length > 0) {
		returnMoney = flight.returnFlight
			? flight.returnFlight.money.filter(money => money.passenger === type)[0].value
			: 0;
	}
	const moneyByType = departureMoney + returnMoney;

	const resultRender = moneyByType > 0 ? 	i18n.translate('label.currency') + ' ' + FormatValue.formatAmount(moneyByType) : '--'

	return (
		<div>
			<span>
				{resultRender}
			</span>
		</div>
	);
}

function countPassagerSplitByType(pnr, type) {
	let cont = 0;
	let objeto = pnr.pnrSplit.pnrChild;
	if (objeto && objeto.length > 0) {
		objeto.map((obj, index) => {
			obj[index].passengers.forEach((passengerChild) => {
				if (passengerChild.passengerType.toString() === type) {
					cont++;
				}
			})
		})
	}
	return cont;
}

function countPassagerSplit(pnr) {
	let cont = 0;
	let objeto = pnr.pnrSplit.pnrChild;
	if (objeto && objeto.length > 0) {
		objeto.map((obj, index) => {
			obj[index].passengers.forEach((passengerChild) => {
				cont++;
			})
		})
	}
	return cont;
}

function renderInfoPaymentWhenPnrSplited(pnrNumber) {
	return (
		<Col span={8} className="text-300 text-right padding-top-xs">
			{i18n.translate('message.infoPaymentWhenPnrSplited')} {' '}
			<span className="text-500" data-test="paymentCardTotal">
				{pnrNumber}
			</span>
		</Col>
	);
}

PaymentDetail.propTypes = propTypes;

export default PaymentDetail;



// WEBPACK FOOTER //
// ./src/page/flightDetailsPage/components/paymentDetail/PaymentDetail.jsx